import {MarketDataEntryType, MarketDataUpdateAction} from './market-data.enums';

export enum MdEntryFieldIndex {
    UPDATE_ACTION,
    TYPE,
    ID,
    REF_ID,
    PX,
    SIZE,
    ORIGINATOR,
    POSITION_NO,
    TIME
}

export type ArrayEncodedMdEntry = [
    MarketDataUpdateAction, // mdUpdateAction
    MarketDataEntryType,    // mdEntryType
    string,                 // mdEntryID
    string,                 // mdEntryRefID
    number,                 // mdEntryPx
    number,                 // mdEntrySize
    string,                 // mdEntryOriginator
    number,                 // mdEntryPositionNo
    string                  // mdEntryTime
    ];
